// 

/**
 * SafeBlankLinks: nastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
 *
 */

const checkNode = (node) => {
  if (node.nodeType === 1 || node.nodeType === 9) {
    const blankLinks = node.querySelectorAll('a[target="_blank"]:not([rel="noopener"])');
    [...blankLinks].forEach((blankLink) => {
      setRel(blankLink);
    });
  }
};
const setRel = (node) => {
  if (node.nodeType === 1 && node.tagName === 'A' && node.target == '_blank' && node.rel != 'noopener') {
    node.rel = 'noopener'
  }
};

export default () => {
  checkNode(document);

  if (window.MutationObserver) {
    const observer = new MutationObserver((mutations, observer) => {
      for (let i = 0; i < mutations.length; i++) {
        for (let j = 0; j < mutations[i].addedNodes.length; j++) {
          checkNode(mutations[i].addedNodes[j]);
        }
      }
    });

    observer.observe(document.body, {
      atributes: false,
      childList: true,
      subtree: true
    });
  }
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/safeBlankLinks.js